import type { DispatchStatus, TripStatus, TripStopStatus } from '@rfleet/shared';

export interface TripRow {
  id: string;
  number: string;
  status: TripStatus;
  dispatchStatus: DispatchStatus;
  vehicleId: string | null;
  driverId: string | null;
  customerId: string | null;
  shipmentOrderNo: string | null;
  cargoType: string | null;
  cargoNotes: string | null;
  originPlaceId: string | null;
  originText: string | null;
  originLat: number | null;
  originLon: number | null;
  destPlaceId: string | null;
  destText: string | null;
  destLat: number | null;
  destLon: number | null;
  originPlace: string | null;
  destPlace: string | null;
  scheduledAt: string | null;
  dueAt: string | null;
  startedAt: string | null;
  endedAt: string | null;
  startOdometerKm: string | null;
  endOdometerKm: string | null;
  distanceKm: string | null;
  distanceSource: 'OBD' | 'PHONE' | 'MANUAL' | null;
  durationSec: number | null;
  maxSpeedKph: number | null;
  podFileId: string | null;
  podReceiverName: string | null;
  endNotes: string | null;
  notes: string | null;
  dispatchedAt: string | null;
  acceptedAt: string | null;
  rejectedAt: string | null;
  rejectReason: string | null;
  cancelReason: string | null;
  createdAt: string;
  vehicle: { id: string; plateAr: string; plateLatin: string | null; name: string | null; type: string } | null;
  driver: { id: string; fullName: string; phone: string; userId: string | null } | null;
  customer: { id: string; name: string; phone: string | null } | null;
}

export interface TripStop {
  id: string;
  seq: number;
  placeId: string | null;
  placeName: string | null;
  customerId: string | null;
  addressText: string | null;
  lat: number | null;
  lon: number | null;
  plannedAt: string | null;
  arrivedAt: string | null;
  departedAt: string | null;
  status: TripStopStatus;
  notes: string | null;
}

export interface TripDetail extends TripRow {
  stops: TripStop[];
  drives: { id: string; startedAt: string; endedAt: string | null; distanceKm: string; durationSec: number | null; maxSpeedKph: number | null }[];
  events: { type: string; at: string; note?: string | null }[];
  suggestedOdometerKm: number | null;
}

export interface TripRoute {
  points: { at: string; lat: number; lon: number; speedKph: number | null; heading: number | null }[];
  totalPoints: number;
}

export const tripTone = (s: TripStatus): 'success' | 'warning' | 'info' | 'neutral' | 'danger' =>
  s === 'IN_PROGRESS' ? 'success' : s === 'PAUSED' ? 'warning' : s === 'SCHEDULED' ? 'info' : s === 'CANCELLED' ? 'danger' : 'neutral';

export const dispatchTone = (s: DispatchStatus): 'success' | 'warning' | 'danger' | 'neutral' => (s === 'ACCEPTED' ? 'success' : s === 'PENDING' ? 'warning' : s === 'REJECTED' ? 'danger' : 'neutral');

export const pointLabel = (t: Pick<TripRow, 'originPlace' | 'originText' | 'destPlace' | 'destText'>, which: 'origin' | 'dest') =>
  which === 'origin' ? (t.originPlace ?? t.originText ?? null) : (t.destPlace ?? t.destText ?? null);
